import FieldForm from "../FieldForm";
import styles from "../Overlay/Overlay.module.css"
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
    SelectRoot,
    SelectTrigger,
    SelectContent,
    SelectItem
} from "../ui/select"
import { useState, useEffect } from "react";
import { editCar } from "../../api/cars.api";
import { getTecnicos } from "../../api/tecnicos.api";
import HeaderForm from "../HeaderForm";
import Overlay from "../Overlay";
import ButtonForm from "../ButtonForm";
import LabelRequired from "../LabelRequired";
import FieldFormRequired from "../FieldFormRequired";

const marcasPorModelo = {
    "Uno": "Fiat",
    "Uno Mille": "Fiat",
    "Kwid": "Renault",
    "Ka": "Ford",
    "Up!": "Volkswagen",
    "Palio": "Fiat",
    "Argo": "Fiat",
    "Siena": "Fiat",
    "Fiorino": "Fiat",
    "Celta": "Chevrolet",
    "Classic": "Chevrolet",
    "Montana": "Chevrolet",
    "Gol": "Volkswagen",
    "Saveiro": "Volkswagen",
    "Sandero": "Renault",
    "Fiesta": "Ford",
    "Focus": "Ford",
    "Doblo": "Fiat"
}



function FormEditCar({ setIsOpen, entity }) {
    const [model, setModel] = useState(entity.model);
    const [marca, setMarca] = useState(entity.marca);
    const [placa, setPlaca] = useState(entity.placa);
    const [color, setColor] = useState(entity.color);
    const [tecnicos, setTecnicos] = useState([])
    const [tecnicoId, setTecnicoId] = useState(entity?.tecnico?.id.toString() ?? "0");
   

    useEffect(() => {
        getTecnicos()
            .then(res => setTecnicos(res.data))
            .catch((error) => {
                setTecnicos([])
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            });
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const carData = {
            Id: entity.id,
            Model: model,
            Marca: marca,
            Placa: placa.toUpperCase(),
            Color: color,
            TecnicoId: tecnicoId === "0" ? null : Number(tecnicoId)
        };

        await editCar(carData)
            .then(() => {
                setIsOpen(false);
                toast.success("Carro editado!");
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })

    }

    const handleModelChange = (novoModelo) => {
        setModel(novoModelo);

        const marcaCorrespondente = marcasPorModelo[novoModelo];

        if (marcaCorrespondente) {
            setMarca(marcaCorrespondente);
        }
    };

    return (
        <Overlay>
            <form onSubmit={handleSubmit}>
                <HeaderForm 
                    title="Editar Carro"
                    close={() => setIsOpen(false)}
                />
                <div className={styles.select}>
                    <LabelRequired>Modelo</LabelRequired>
                    <SelectRoot value={model} onValueChange={handleModelChange}>
                        <SelectTrigger />
                        <SelectContent>
                            <SelectItem value="Uno">Uno</SelectItem>
                            <SelectItem value="Uno Mille">Uno Mille</SelectItem>
                            <SelectItem value="Kwid">Kwid</SelectItem>
                            <SelectItem value="Ka">Ka</SelectItem>
                            <SelectItem value="Up!">Up!</SelectItem>
                            <SelectItem value="Palio">Palio</SelectItem>
                            <SelectItem value="Argo">Argo</SelectItem>
                            <SelectItem value="Siena">Siena</SelectItem>
                            <SelectItem value="Fiorino">Fiorino</SelectItem>
                            <SelectItem value="Celta">Celta</SelectItem>
                            <SelectItem value="Onix">Onix</SelectItem>
                            <SelectItem value="Classic">Classic</SelectItem>
                            <SelectItem value="Montana">Montana</SelectItem>
                            <SelectItem value="Gol">Gol</SelectItem>
                            <SelectItem value="Saveiro">Saveiro</SelectItem>
                            <SelectItem value="Sandero">Sandero</SelectItem>
                            <SelectItem value="Fiesta">Fiesta</SelectItem>
                            <SelectItem value="Focus">Focus</SelectItem>
                            <SelectItem value="Doblo">Doblo</SelectItem>
                        </SelectContent>
                    </SelectRoot>
                </div>
                <FieldFormRequired
                    type="text"
                    placeholder="LSK5834"
                    field="Placa"
                    setThing={setPlaca}
                    value={placa}
                />
                <div className={styles.containerSelect}>
                    <div className={styles.select}>
                        <LabelRequired>Cor</LabelRequired>
                        <SelectRoot value={color} onValueChange={setColor}>
                            <SelectTrigger />
                            <SelectContent>
                                <SelectItem value="Azul">Azul</SelectItem>
                                <SelectItem value="Vermelho">Vermelho</SelectItem>
                                <SelectItem value="Verde">Verde</SelectItem>
                                <SelectItem value="Branco">Branco</SelectItem>
                                <SelectItem value="Preto">Preto</SelectItem>
                                <SelectItem value="Prata">Prata</SelectItem>
                            </SelectContent>
                        </SelectRoot>
                    </div>
                    <div className={styles.customField}>
                        <label>Marca</label>
                        <input
                            type="text"
                            readOnly
                            value={marca}
                        />
                    </div>
                </div>
                <div className={styles.select}>
                    <label>Técnico Responsável</label>
                    <SelectRoot value={tecnicoId} onValueChange={setTecnicoId}>
                        <SelectTrigger />
                        <SelectContent>
                            <SelectItem value="0">Nenhum</SelectItem>
                            {Array.isArray(tecnicos) ? tecnicos.map((tecnico, index) => {
                                return <SelectItem value={tecnico.id.toString()} key={index + 1}>{tecnico.name}</SelectItem>
                            }) : ""}
                        </SelectContent>
                    </SelectRoot>
                </div>
                <ButtonForm>Editar</ButtonForm>
            </form >
        </Overlay>
    )
}


export default FormEditCar;